import IconAsMaskImage from "../IconAsMaskImage";

const Timer = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <g transform="translate(0.347 0.347)">
          <rect
            width="18"
            height="18"
            transform="translate(17.653 17.653) rotate(180)"
            fill="#757575"
            opacity="0"
          />
          <path
            d="M9.179,2a7.179,7.179,0,1,0,7.179,7.179A7.179,7.179,0,0,0,9.179,2Zm0,12.921a5.743,5.743,0,1,1,5.743-5.743A5.743,5.743,0,0,1,9.179,14.921Z"
            transform="translate(-0.564 -0.564)"
            fill="#757575"
          />
          <path
            d="M14.589,9.871H12.436V7.718a.718.718,0,0,0-1.436,0v2.871a.718.718,0,0,0,.718.718h2.871a.718.718,0,0,0,0-1.436Z"
            transform="translate(-3.104 -1.975)"
            fill="#757575"
          />
        </g>
      </svg>
    </>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default Timer;
